// 足球
// 状态码 |    描述
// | ------ | ------------------------------------------------------------------------------
// | 0      | 比赛异常，说明：暂未判断具体原因的异常比赛，可能但不限于：腰斩、取消等等，建议隐藏处理
// | 1      | 未开赛
// | 2      | 上半场
// | 3      | 中场
// | 4      | 下半场
// | 5      | 加时赛
// | 6      | 加时赛(弃用)
// | 7      | 点球决战
// | 8      | 完场
// | 9      | 推迟
// | 10     | 中断
// | 11     | 腰斩
// | 12     | 取消
// | 13     | 待定

// 篮球
// 状态码 | 描述
// | ------ | ------------------------------------------------------------------------------
// | 0 | 比赛异常，说明：暂未判断具体原因的异常比赛，可能但不限于：腰斩、取消等等，建议隐藏处理
// | 1 | 未开赛
// | 2 | 第一节
// | 3 | 第一节完
// | 4 | 第二节
// | 5 | 第二节完
// | 6 | 第三节
// | 7 | 第三节完
// | 8 | 第四节
// | 9 | 加时
// | 10 | 完场
// | 11 | 中断
// | 12 | 取消
// | 13 | 延期
// | 14 | 腰斩
// | 15 | 待定

import React from 'react';
import {
    withStyles,
    Grid,
    Typography,
    Avatar,
    Divider,
    withRouter
} from '../../../material-ui';
import DateUtils from '../../../control/dateutils'
import Match from '../../../model/Match';
import AppData from '../../../model/AppData';
import ToName from '../../../control/ToName';
import AppUtils from '../../../control/apputlis';
import Apis from '../../../network/Apis';
import AppConfig from '../../../control/config';

// const ICON = require("../../../images/icons/faxian_icon.png");
// const VSIMG = require("../../../images/icons/vsb.png");
// const ICON_RECOMM = require('../../../images/icons/tuijian.png');
// const ICON_HOT = require("../../../images/icons/remenr.png");
// const ICON_SC = require("../../../images/icons/shoucan.png");
// const ICON_SCT = require("../../../images/icons/shoucan2.png");
// const PLAYICON = require("../../../images/icons/living.gif");
// const ICON_SOURCE = require("../../../images/icons/ic_nami_soruce.png");
// const ICON_TITLE_BACK = require("../../../images/bg/sichengtitleback.png");
// const ICON_ARROW_1 = require("../../../images/icons/jiantou1.png");
// const ICON_ARROW_2 = require("../../../images/icons/jiantou2.png");

class MatchItem extends React.Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {

    }


    _onClicAnchor = async (e, data) => {
        let room_id = data.room_id ? data.room_id : 0;
        let match_type = data.match_type ? data.match_type : 0;
        let match_id = data.match_id ? data.match_id : 0;
        if (match_id == 0) {
            match_id = data.id;
        }
        if (match_type == 0) {
            match_type = data.type_id
        }
        //点击了赛程
        e.stopPropagation();
        if (match_id > 0 && match_type > 0) {
            let result = await Apis.encryptionJumpToRoom(match_type, match_id);
            console.log("toPlay:" + result);
            if (result.code == 200) {
                if (result.data != 0) {
                    room_id = result.data
                }
            }
        }

        let os = 'h5';
        if (AppData.os !== '') {
            os = AppData.os
        }
        let token = 0;

        if (AppData.me.token !== '') {
            token = AppData.me.token
        }

        let customerId = 0
        if (AppData.me.customer_id && AppData.me.customer_id != 0 && AppData.me.customer_id != '') {
            customerId = AppData.me.customer_id
        }
        let uid = AppUtils.getStorageItem('uid');
        let fastkey = AppUtils.getStorageItem("fastkey");
        let roomIp = AppUtils.getStorageItem("roomIp");
        let roomPort = AppUtils.getStorageItem("roomPort");
        let channel = AppUtils.getStorageItem("channel")
        if (!channel) {
            channel = AppConfig.channelid
        }
        let fid = AppData.me.free_id

        ToName(this.props, `/play/${room_id}/${match_type}/${match_id}/${uid}/${fastkey}/${roomIp}/${roomPort}/${os}/${token}/${customerId}/${fid}/${channel}`, data)

    }

    showPlay = (data) => {
        if (!data.nami) {
            return false;
        }
        if (data.nami.length == 0) {
            return false;
        }
        let liveSource = '';
        data.nami.forEach(element => {
            if (element.live_url.length > 0) {
                liveSource = element.live_url;
            }
        });
        return liveSource.length > 0;
    }

    openList = () => {
        this.setState({ isOpen: !this.state.isOpen })
    }

    getTitle = (data) => {
        for (let i = 0; i < data.length; i++) {
            if (data[i].competition_name && data[i].competition_name.length > 0) {
                return data[i].competition_name;
            }
        }
    }

    renderItem = (item, i) => {
        const { classes, line } = this.props;
        let match = new Match(item);

        let status = match.getStatus();
        if (!item.host) {
            item.host = [];
        }

        let statusColor = "#0D0D0D"
        if (item.host.length > 0 && status !== "完场") {
            status = "视频直播"
            statusColor = "#ED3C2F"
        }
        if (status == "直播中") {
            statusColor = "#ED3C2F"
        }

        if (item.status !== 8) {
            let time = DateUtils.dateFormatHM(item.match_time);
            status = `${time} ${status}`
        }

        let awayScore = match.getAwayScore()
        let homeScore = match.getHomeScore()

        return (
            <Grid onClick={(e) => this._onClicAnchor(e, item)} container direction='column' justifyContent='space-between' alignItems='center' className={classes.itemRow}>
                <Grid container direction='row' justifyContent='space-between' alignItems='center'>
                    <Grid container direction='column' justifyContent='space-between' className={classes.columnBox} style={{ width: '60%', height: 60 }}>
                        <Grid container direction='row' justifyContent='space-between' className={classes.teamBox}>
                            <Grid container direction='row' alignItems='center' className={classes.teamLeft}>
                                <Avatar src={item.home_log} className={classes.logo}></Avatar>
                                <div className={classes.teamName}>{item.home_name}</div>
                            </Grid>
                            <span className={classes.fen} style={{ color: item.home_scores[0] == 0 ? '#303030' : '#222222' }}>
                                {homeScore}
                            </span>
                        </Grid>
                        <Grid container direction='row' justifyContent='space-between' className={classes.teamBox}>
                            <Grid container direction='row' alignItems='center' className={classes.teamLeft}>
                                <Avatar src={item.away_log} className={classes.logo}></Avatar>
                                <div className={classes.teamName}>{item.away_name}</div>
                            </Grid>
                            <span className={classes.fen} style={{ color: item.away_scores[0] == 0 ? '#303030' : '#222222' }}>
                                {awayScore}
                            </span>
                        </Grid>
                    </Grid>
                    <Grid container direction='column' alignItems='flex-end' justifyContent='center' style={{ width: '40%', height: 60 }}>
                        <div className={classes.status} style={{ color: item.status == 8 ? '#909090' : statusColor }}>{status}</div>
                        <div className={classes.statusName}>{item.competition_name}</div>
                    </Grid>
                </Grid>
                {
                    item.host.length > 0 &&
                    <Divider style={{ backgroundColor: '#F2F2F2', height: 1, width: '100%', marginTop: 10, marginBottom: 10 }} />

                }
                {item.host.length > 0 &&
                    <Grid className={classes.userListBox}  >
                        <div className={classes.userName}>主播：</div>
                        <Grid container direction='row'>
                            {item.host.map((data, i) => <Grid key={i + 'o'} >
                                <Grid onClick={(e) => this._onClicAnchor(e, data)} container direction='column' alignItems='center' style={{ marginRight: 10 }} >
                                    <Avatar className={classes.avatar} src={data.portrait}></Avatar>
                                    <div className={classes.nickName}>{data.nickName}</div>
                                </Grid>
                            </Grid>)}
                        </Grid>
                    </Grid>
                }
            </Grid>
        );
    }

    render() {
        const { classes, line, data, showDate } = this.props;
        let title = DateUtils.dateFormatMatch(data.match_time)
        return (
            <Grid container direction='column' className={classes.listBox}>
                {
                    showDate && <Grid container direction='row'>
                        <Typography className={classes.title}>{title}</Typography>
                    </Grid>
                }

                <Grid className={classes.itemBox} >
                    {this.renderItem(data)}
                </Grid>
            </Grid >
        );
    }

}

export default withRouter(withStyles((theme) => ({
    avatar: {
        width: 28,
        height: 28
    },
    userListBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    nickName: {
        fontSize: 10,
        color: '#878787',
        marginTop: 5
    },
    userName: {
        fontSize: 12,
        color: '#303030',
        width: 60
    },
    status: {
        fontSize: 14,
        color: '#0D0D0D',
        marginBottom: 5
    },
    statusName: {
        fontSize: 9,
        color: '#878787',
        width: '90%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        textAlign: 'right'
    },
    columnBox: {
        borderRight: '1px solid #E2E2E2'
    },
    fen: {
        fontSize: 15,
        fontWeight: 'bold',
        marginRight: 20
    },
    teamBox: {
        width: '100%',
        flexWrap: 'nowrap'
    },
    teamLeft: {
        width: '70%',
        flexWrap: 'nowrap'
    },
    teamName: {
        fontSize: 13,
        color: '#222',
        marginLeft: 20,
        width: '70%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'

    },
    itemRow: {
        margin: 15,
        paddingRight: 30
    },
    logo: {
        width: 25,
        height: 25
    },
    listBox: {
        width: '100%',
        paddingLeft: 10,
        paddingRight: 10,
    },
    itemBox: {
        // height: 90,
        width: '100%',
        backgroundColor: '#fff',
        marginRight: 10,
        marginTop: 8,
        borderRadius: 10,
        overflow: 'hidden',
    },

    title: {
        fontSize: 12,
        color: '#303030',
        marginTop: 10
    },

}))(MatchItem));